import { render, staticRenderFns } from "./PageViewsGrouped.vue?vue&type=template&id=0d94074e"
import script from "./PageViewsGrouped.vue?vue&type=script&lang=js"
export * from "./PageViewsGrouped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports